import script from "./TrazabilidadView.vue?vue&type=script&lang=ts&setup=true"
export * from "./TrazabilidadView.vue?vue&type=script&lang=ts&setup=true"

import "./TrazabilidadView.vue?vue&type=style&index=0&id=0b16d154&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b16d154"]])

export default __exports__